<!--
 * @Author: wjl
 * @Date: 2021-01-13 16:12:15
 * @LastEditors: wjl
 * @LastEditTime: 2021-02-18 10:11:43
 * @FilePath: \appOfficial\src\App.vue
-->
<template>
  <div id="app">
    <keep-alive include="yinsi">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      showModel: -1,
      modelList: [],
      lang: "",
    };
  },
  mounted() {
    // this.modelList = this.$t("modelList");
    // window.localStorage.getItem("user_lang") == null
    //   ? (this.lang = "ch")
    //   : (this.lang = window.localStorage.getItem("user_lang"));
  },
  methods: {
    // change(name) {
    //   window.localStorage.setItem("user_lang", name);
    //   location.reload();
    // },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #7e7e7e;
  font-size: 14px;
  background: #fff;
  overflow: hidden;
}
html,
body {
  margin: 0;
}
h1,
h2,
p {
  margin: 0;
}
</style>

<style lang="scss"></style>
